// Version : 0.0.5
// Author : ARAVINDHAN
// LastEdit : KARTHEESWARAN
// LastAdd : DESTRUCTURING PAYLOAD VALUES
// MODFIED DATA : 13-08-2025
import { takeLatest, put, all, call } from 'redux-saga/effects';

import PurposeOfLoanTypeActionTypes from './purpose-of-loan-type.types';
import {
	getPurposeOfLoanTypeList,
	addPurposeOfLoanType,
	purposeofLoanTypeDetailsDelete,
	purposeofLoanTypeDetailsFetch,
	purposeofLoanTypeDetailsUpdate,
} from './purpose-of-loan-type.service';

import {
	getPurposeOfLoanTypeSuccess,
	getPurposeOfLoanTypeFailure,
	getPurposeOfLoanTypeResponseChanged,
	addPurposeOfLoanTypeSuccess,
	addPurposeOfLoanTypeFailure,
	addPurposeOfLoanTypeResponseChanged,
	deletePurposeOfLoanTypeSuccess,
	deletePurposeOfLoanTypeFailure,
	deletePurposeOfLoanTypeResponseChanged,
	fetchPurposeOfLoanTypeDetailsSuccess,
	fetchPurposeOfLoanTypeDetailsFailure,
	fetchPurposeOfLoanTypeDetailsResponseChanged,
	updatePurposeOfLoanTypeDetailsSuccess,
	updatePurposeOfLoanTypeDetailsFailure,
	updatePurposeOfLoanTypeDetailsResponseChanged,
} from './purpose-of-loan-type.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
// PURPOSE OF LOAN TYPE
/** *************** GET PURPOSE OF LOAN TYPE LIST START ***************** */

export function* purposeOfLoanTypeListStart({ payload }: any) {
	try {
		const { companyID, userID, databaseName, inputSearch, limit } = payload;
		const key = 'purposeOfLoanTypeListKey';
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
			InputSearch: inputSearch,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getPurposeOfLoanTypeList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPurposeOfLoanTypeFailure(responseData.data));
		} else {
			yield put(getPurposeOfLoanTypeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPurposeOfLoanTypeFailure(error));
	}
}

export function* purposeOfLoanTypeListReset() {
	yield put(getPurposeOfLoanTypeResponseChanged());
}

export function* onPurposeOfLoanTypeGetStart() {
	yield takeLatest(
		PurposeOfLoanTypeActionTypes.GET_PURPOSE_OF_LOAN_TYPE_START,
		purposeOfLoanTypeListStart,
	);
}

export function* onPurposeOfLoanTypeGetReset() {
	yield takeLatest(
		PurposeOfLoanTypeActionTypes.GET_PURPOSE_OF_LOAN_TYPE_RESPONSE_RESET,
		purposeOfLoanTypeListReset,
	);
}

/** *************** GET PURPOSE OF LOAN TYPE END  ***************** */

/** *************** ADD PURPOSE OF LOAN TYPE START ***************** */
export function* purposeOfLoanTypeAddStart({ payload }: any) {
	try {
		const { companyID, userID, purposeOfLoanTypeName, databaseName } = payload;
		const key = 'purposeOfLoanTypeCreateKey';
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			PurposeOfLoanTypeName: purposeOfLoanTypeName,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addPurposeOfLoanType, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addPurposeOfLoanTypeFailure(responseData.data));
		} else {
			yield put(addPurposeOfLoanTypeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addPurposeOfLoanTypeFailure(error));
	}
}

export function* purposeOfLoanTypeAddReset() {
	yield put(addPurposeOfLoanTypeResponseChanged());
}

export function* onPurposeOfLoanTypeAddStart() {
	yield takeLatest(
		PurposeOfLoanTypeActionTypes.ADD_PURPOSE_OF_LOAN_TYPE_START,
		purposeOfLoanTypeAddStart,
	);
}

export function* onPurposeOfLoanTypeAddReset() {
	yield takeLatest(
		PurposeOfLoanTypeActionTypes.ADD_PURPOSE_OF_LOAN_TYPE_RESPONSE_RESET,
		purposeOfLoanTypeAddReset,
	);
}

/** *************** ADD PURPOSE OF LOAN TYPE END  ***************** */

/** *********************  START DELETE PURPOSE OF LOAN DETAILS  ******************** */
export function* purposeofLoanTypeDelete({ payload }: any) {
	try {
		const {
			userID,
			userAccessBranchID,
			companyID,
			databaseName,
			PurposeOfLoanTypeID,
			PurposeOfLoanTypeName,
			userName,
		} = payload;
		const key = 'DeletePurposeOfLoanTypeDetailsKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			PurposeOfLoanTypeID: PurposeOfLoanTypeID,
			PurposeOfLoanTypeName: PurposeOfLoanTypeName,
			UserName: userName,
			DeletedBy: userID,
			UserAccessBranchID: userAccessBranchID,
			IsActive: '0',
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(purposeofLoanTypeDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deletePurposeOfLoanTypeFailure(responseData.data));
		} else {
			yield put(deletePurposeOfLoanTypeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deletePurposeOfLoanTypeFailure(error));
	}
}

export function* resetDeletePurposeOfLoanTypeDetailsResponse() {
	yield put(deletePurposeOfLoanTypeResponseChanged());
}

export function* onDeletePurposeOfLoanTypeDetail() {
	yield takeLatest(
		PurposeOfLoanTypeActionTypes.DELETE_PURPOSE_OF_LOAN_TYPE_START,
		purposeofLoanTypeDelete,
	);
}

export function* onDeletePurposeOfLoanResponseReset() {
	yield takeLatest(
		PurposeOfLoanTypeActionTypes.DELETE_PURPOSE_OF_LOAN_TYPE_RESPONSE_RESET,
		resetDeletePurposeOfLoanTypeDetailsResponse,
	);
}
/** *********************  END DELETE PURPOSE OF LOAN DETAILS ******************** */

/** *********************  START FETCH PURPOSE OF LOAN DETAILS  ******************** */
export function* fetchPurposeOfLoanData({ payload }: any) {
	try {
		const { companyID, purposeOfLoanTypeID, databaseName } = payload;
		const key = 'FetchPurposeOfLoanTypeDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			PurposeOfLoanTypeID: purposeOfLoanTypeID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(purposeofLoanTypeDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchPurposeOfLoanTypeDetailsFailure(responseData.data));
		} else {
			yield put(fetchPurposeOfLoanTypeDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchPurposeOfLoanTypeDetailsFailure(error));
	}
}

export function* resetFetchPurposeOfLoanTypeDetailsResponse() {
	yield put(fetchPurposeOfLoanTypeDetailsResponseChanged());
}

export function* onFetchPurposeOfLoanTypeDetails() {
	yield takeLatest(
		PurposeOfLoanTypeActionTypes.FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_START,
		fetchPurposeOfLoanData,
	);
}

export function* onFetchPurposeOfLoanTypeResponseReset() {
	yield takeLatest(
		PurposeOfLoanTypeActionTypes.FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_RESPONSE_RESET,
		resetFetchPurposeOfLoanTypeDetailsResponse,
	);
}
/** *********************  END FETCH PURPOSE OF LOAN DETAILS ******************** */

/** *********************  START UPDATE PURPOSE OF LOAN DETAILS  ******************** */
export function* purposeofLoanUpdate({ payload }: any) {
	try {
		const {
			purposeOfLoanTypeID,
			purposeOfLoanTypeName,
			companyID,
			userID,
			userName,
			userAccessBranchID,
			databaseName,
		} = payload;
		const key = 'UpdatePurposeOfLoanTypeDetailsKey';
		const jsonData = {
			PurposeOfLoanTypeID: purposeOfLoanTypeID,
			PurposeOfLoanTypeName: purposeOfLoanTypeName,
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(purposeofLoanTypeDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updatePurposeOfLoanTypeDetailsFailure(responseData.data));
		} else {
			yield put(updatePurposeOfLoanTypeDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updatePurposeOfLoanTypeDetailsFailure(error));
	}
}

export function* resetUpdatePurposeOfLoanTypeDetailsResponse() {
	yield put(updatePurposeOfLoanTypeDetailsResponseChanged());
}

export function* onUpdatePurposeOfLoanTypeDetails() {
	yield takeLatest(
		PurposeOfLoanTypeActionTypes.UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_START,
		purposeofLoanUpdate,
	);
}

export function* onUpdatePurposeOfLoanTypeResponseReset() {
	yield takeLatest(
		PurposeOfLoanTypeActionTypes.UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_RESPONSE_RESET,
		resetUpdatePurposeOfLoanTypeDetailsResponse,
	);
}
/** *********************  END UPDATE PURPOSE OF LOAN DETAILS ******************** */

export function* purposeofLoanTypeSaga() {
	yield all([
		call(onPurposeOfLoanTypeGetStart),
		call(onPurposeOfLoanTypeGetReset),
		call(onPurposeOfLoanTypeAddStart),
		call(onPurposeOfLoanTypeAddReset),
		call(onDeletePurposeOfLoanTypeDetail),
		call(onDeletePurposeOfLoanResponseReset),
		call(onFetchPurposeOfLoanTypeDetails),
		call(onFetchPurposeOfLoanTypeResponseReset),
		call(onUpdatePurposeOfLoanTypeDetails),
		call(onUpdatePurposeOfLoanTypeResponseReset),
	]);
}
